module.exports = __webpack_public_path__ + "img/colas-de-rienzo.12ac95d6.jpg";